import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import { useEffect, useContext } from "react";
import { CommonServiceContext } from "../../../services/common/commonService";
import Loader from "../../../components/Loader";
import pin from "../../../assets/images/pin.png";

const MyMapComponent = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      defaultZoom={8}
      defaultCenter={{ lat: 41.7425841, lng: 44.7791404 }}
    >
      {props.locations.map((loc) => (
        <Marker position={{ lat: loc.latitude, lng: loc.longitude }} />
      ))}
      <Marker position={{ lat: -32.397, lng: 150.644 }} />
    </GoogleMap>
  ))
);

const Map = () => {
  const { getHomePage, officeLocations, loading } =
    useContext(CommonServiceContext);

  const getHomeContent = async () => {
    await getHomePage();
  };

  useEffect(() => {
    getHomeContent();
  }, []);

  return (
    <>
      {loading && <Loader />}
      {officeLocations && (
        <>
          <div className="className=py-10 lg:py-20 mt-60">
            <div className="container">
              <div class="relative h-screen">
                <div class="absolute inset-0">
                  <MyMapComponent
                    isMarkerShown
                    googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: `650px` }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                    locations={officeLocations}
                  />
                </div>
                <div class="absolute top-16 right-0 w-2/4 h-11/12  p-6 overflow-y-auto">
                  <div class="grid grid-cols-2 gap-4">
                    {officeLocations.map((loc) => (
                      <div className="flex items-center gap-4 p-4 bg-gray-100 rounded-lg shadow">
                        <img
                          src={pin}
                          alt="Location Pin"
                          class="w-10 h-10 object-contain"
                        />
                        <div>
                          <p class="text-sm font-semibold text-gray-800">
                            {loc.addressName}
                          </p>
                          <p class="text-sm text-gray-600">{loc.phone}</p>
                        </div>
                      </div>
                      // <div className="map-address">
                      //   <div className="map-pin">
                      //     <img src={pin} />
                      //   </div>
                      //   <div className="map-address-container">
                      //     <h3 className="map-address-content">
                      //       {loc.addressName}
                      //     </h3>
                      //     <h3 className="map-address-content">{loc.phone}</h3>
                      //   </div>
                      // </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Map;
